// /api/colle.js

import baseURL from './config'
import axios from 'axios'
import qs from 'qs'
const local = require('./local')
axios.defaults.baseURL = baseURL
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'

// 清除回收站文件
export const clearColle = async function(selid, nationcode) {
    var user = local.useGetter()
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
        itemid: selid
    }
    var validRes = function() {
        return new Promise(function(resolve) {
            axios.post(
                '/?r=v1/colle/colle-clear', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    var result = await validRes()
    return result
}

// 文件还原
export const genRowRevert = async function(selid, nationcode) {
    var user = local.useGetter()
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
        itemid: selid
    }
    var validRes = function() {
        return new Promise(function(resolve, reject) {
            axios.post(
                '/?r=v1/colle/row-revert', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    var result = await validRes()
    return result
}

// 获取回收站列表
export const getAllItem = async function(pager, nationcode) {
    var user = local.useGetter()
    var postData = {
        author: user.username,
        token: user.token,
        nationcode: user.usercode,
        pager: pager
    }
    var validRes = function() {
        return new Promise(function(resolve, reject) {
            axios.post(
                '/?r=v1/colle/flist', qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    var result = await validRes()
    return result
}

// 文件分页
export const chunkData = async function(cdir, pager, nationcode) {
    var user = local.useGetter()
    var postData = {
        author: user.username,
        cdir: cdir,
        pager: pager,
        nationcode: user.usercode,
        token: user.token
    }
    var validRes = function() {
        return new Promise(function(resolve) {
            axios.post(
                '/?r=v1/colle/data-chunk',
                qs.stringify(postData)
            ).then(
                (res) => { resolve(res) },
                (err) => { reject(err) }
            )
        })
    }
    var result = await validRes()
    return result
}

export default axios



//////////////////
// WEBPACK FOOTER
// ./api/colle.js
// module id = 0Y31
// module chunks = 0